// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"314":"df35aa18","552":"3cb58fb1","762":"df35aa18"}[chunkId] + ".chunk.css";
};